<template>
    <div>
        <b-modal v-if="showModalWithdrawBookings" v-model="showModalWithdrawBookings" :show-close="true" :noCloseOnBackdrop="true" 
            :noCloseOnEsc="true" size="lg" footer-class="pb-0" header-class="pb-0">
            <template #modal-header class="pb-0">
                <div class="w-100 pb-0" style="padding-bottom: 0%;">
                    <b-row class="border-bottom">
                        <b-col class="text-left">
                            <h4>Lista de reservas da retirada #{{ currentWithdraw.id }}</h4>
                        </b-col>

                        <b-col class="text-right">
                            <button @click.prevent="emitCloseWithdrawBookingsModal()" type="button" class="close" aria-label="Fechar">
                                <span @click.prevent="emitCloseWithdrawBookingsModal()" class="no no-e-remove"></span>
                            </button>
                        </b-col>
                    </b-row>

                    <b-row align-h="between" class="pt-2">
                        <b-col cols="3" style="margin-left:5px;">
                            <el-select v-model="pagination.perPage" @change="perPageChange" placeholder="Por página" class="select-primary pagination-select" style="margin-bottom: 0%;">
                                <el-option class="select-primary" v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
                                </el-option>
                            </el-select>
                        </b-col>

                        <b-col cols="3" style="margin-right:5px; margin-bottom: 0%;">
                            <base-input v-model="searchQuery" prepend-icon="fas fa-search" placeholder="Buscar..." style="margin-bottom: 0%;"></base-input>
                        </b-col>
                    </b-row>
                </div>
            </template>

            <div>
                <el-table :data="queriedData" @sort-change="sortChange" ref="multipleTable" row-key="id" empty-text="Sem reservas registradas."
                    class="table-responsive table-flush" header-row-class-name="thead-light" table-layout="fixed" style="padding-bottom: 0%; padding-top: -5%;">

                    <el-table-column prop="id" label="ID" :sortable="true">
                    </el-table-column>

                    <el-table-column label="Valor" prop="value" :sortable="true">
                        <template slot-scope="scope">
                            {{ formatCurrency(Number(scope.row.value)) }}
                        </template>
                    </el-table-column>

                    <el-table-column label="Valor final" prop="final_value" :sortable="true">
                        <template slot-scope="scope">
                            {{ formatCurrency(Number(scope.row.final_value)) }}
                        </template>
                    </el-table-column>

                    <el-table-column width="200" prop="pm" label="Forma de Pagamento" :sortable="true">
                    </el-table-column>
                </el-table>
            </div>

            <template #modal-footer>
                <div class="w-100">
                    <b-row>
                        <b-col class="text-left">
                            <p>Mostrando {{ from + 1 }} - {{ to }} de {{ total }} entradas</p>
                        </b-col>

                        <b-col class="text-left">
                            <base-pagination :current="pagination.currentPage" :per-page="pagination.perPage" :total="total" @change="paginationChanged($event)">
                            </base-pagination>
                        </b-col>

                        <b-col class="text-right">
                            <b-button size="sm" @click="emitCloseWithdrawBookingsModal()">Fechar</b-button>
                        </b-col>
                    </b-row>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import usePaginateTable from "../../Composables/usePaginateTable"
import moment from 'moment';

export default {
    name: 'WithdrawBookingModal',

    setup(props, context) {
        const paginateTable = usePaginateTable(context)

        const total = paginateTable.total
        const from = paginateTable.from
        const to = paginateTable.to
        const queriedData = paginateTable.queriedData
        const pagination = paginateTable.getPagination()
        const billItems = paginateTable.getBillsItems()
        const searchQuery = paginateTable.searchQuery

        function formatDataLocaleString(oldData) { return paginateTable.formatDataLocaleString(oldData) }

        function sortChange(data) { return paginateTable.sortChange(data) }

        function createFuseSearch(keys) { return paginateTable.createFuseSearch(keys) }

        function setBillItems(items) { return paginateTable.setBillsItems(items) }

        return {
            total, from, to, queriedData, pagination, billItems, searchQuery,
            formatDataLocaleString, sortChange, createFuseSearch, setBillItems
        }
    },

    components: {

    },

    props: {
        showModalWithdrawBookings: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        ...mapGetters('withdraw', {
            currentWithdraw: 'getCurrentWithdraw',
            withdrawBookingsList: 'getWithdrawBookingsList',
        }),

    },

    watch: {
        withdrawBookingsList(newValue, oldValue){
            if(newValue){
                this.recreateSearchableTable()
            }
        },
    },

    data() {
        return {

        }
    },

    methods: {
        ...mapActions('', [

        ]),

        emitCloseWithdrawBookingsModal(){ 
            this.$emit('emitCloseWithdrawBookingsModal')
        },

        formatCurrency(value){
            const numero = Number(value)
            return numero.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        },

        formatDate(date, format) { return moment(date).format(format) },

        paginationChanged(page) {
            this.pagination.currentPage = page;
        },

        perPageChange(perPage) {
            this.pagination.perPage = perPage
            this.pagination.currentPage = 1
        },

        recreateSearchableTable() {
            this.withdrawBookingsList.length > 0 ? this.setBillItems(this.withdrawBookingsList) : this.setBillItems([])

            // habilitar busca desses campos na tabela pelo mixin
            this.createFuseSearch([
                'pm', 'id', 'value', 'final_value'
            ])
        },
    },

    mounted() {
        this.recreateSearchableTable()
    },

}
</script>